var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.8671 30.6034C26.9996 31.5717 26.4163 32.0289 25.5413 31.5717L18.3026 27.887C17.4276 27.4298 15.9958 27.4298 15.1208 27.887L7.85557 31.5179C6.98056 31.9482 6.39722 31.5179 6.5298 30.5227L7.74951 22.4005C7.9086 21.4322 7.45784 20.0337 6.79495 19.3344L1.14719 13.4444C0.457787 12.7452 0.696425 12.019 1.65098 11.8576L9.6321 10.5398C10.5866 10.3784 11.7533 9.54466 12.2041 8.65713L15.9693 1.39548C16.42 0.53484 17.1625 0.53484 17.6132 1.39548L21.3254 8.68402C21.7761 9.57156 22.9163 10.4053 23.8708 10.5936L31.852 11.9921C32.8065 12.1535 33.0451 12.8796 32.3557 13.5789L26.6549 19.4151C25.9655 20.1144 25.5148 21.486 25.6739 22.4543L26.8406 30.5765L26.8671 30.6034Z",
    fill: "#FF970A",
    stroke: "#FF970A",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFill);
export default __webpack_public_path__ + "static/media/star-fill.3f27044b0b81e00606e9c5e60c17263b.svg";
export { ForwardRef as ReactComponent };